import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#385f73',
        background: '#ffffff'
      },
    }
  }
}

export default new Vuetify(opts)
